import { Chip, Grid, Stack, Typography } from "@mui/material";

import { DrillDownChip, ManagementWidgetShell } from "./managementDashboardWidgets";

const OperationalReadinessSection = ({ loading, error, data, onRetry }) => {
  const categories = data?.categories || data?.Categories || [];
  const overlapNote = data?.overlapNote || data?.OverlapNote;

  return (
    <ManagementWidgetShell
      title="آمادگی عملیاتی"
      subheader="دسته‌ها ممکن است هم‌پوشانی داشته باشند"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      {overlapNote ? (
        <Typography variant="caption" color="text.secondary" sx={{ display: "block", mb: 2 }}>
          {overlapNote}
        </Typography>
      ) : null}
      <Grid container spacing={1}>
        {categories.map((cat) => {
          const code = cat.code || cat.Code;
          const isControl = cat.isControlMetric || cat.IsControlMetric;
          return (
            <Grid item xs={12} sm={6} md={4} key={code}>
              <Stack
                spacing={1}
                sx={{
                  p: 1.5,
                  border: "2px solid",
                  borderColor: isControl ? "error.main" : "divider",
                  borderRadius: 1,
                  height: "100%",
                }}
              >
                <Typography fontWeight={700}>{cat.persianTitle || cat.PersianTitle}</Typography>
                <Typography variant="body2" color="text.secondary">
                  {cat.description || cat.Description}
                </Typography>
                {isControl ? <Chip size="small" color="error" label="متریک کنترلی" /> : null}
                <DrillDownChip
                  drillDown={cat.drillDown || cat.DrillDown}
                  label="تعداد"
                  count={cat.count ?? cat.Count}
                />
              </Stack>
            </Grid>
          );
        })}
      </Grid>
    </ManagementWidgetShell>
  );
};

export default OperationalReadinessSection;
